import * as React from 'react';
const SvgAppointment1 = (props) => (
  <svg
    width={'172px'}
    height={'103px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10664_8817)">
      <path
        d="M5.77539 101.347H166.223"
        stroke="#D7DAEB"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M138.344 25.3029H33.8986C31.7506 25.3029 29.8711 27.183 29.8711 29.3317V96.7461C29.8711 98.8948 31.7506 98.089 33.8986 98.089H138.075C140.223 98.089 142.102 98.8948 142.102 96.7461V29.3317C142.371 27.183 140.492 25.3029 138.344 25.3029Z"
        fill="#D7DAEB"
      />
      <path
        d="M134.714 29.2205H37.5137C35.5147 29.2205 33.7656 30.9036 33.7656 32.8272V93.1793C33.7656 95.1029 35.5147 94.3816 37.5137 94.3816H134.464C136.463 94.3816 138.212 95.1029 138.212 93.1793V32.8272C138.462 30.9036 136.713 29.2205 134.714 29.2205Z"
        fill="white"
      />
      <path
        d="M98.0577 64.3061C97.8021 65.3842 97.4181 66.4207 96.9489 67.3743C95.7129 69.6132 93.8793 71.4375 91.5771 72.557C89.1891 73.7593 86.3751 74.1739 83.5185 73.6349C76.8669 72.2667 72.5607 65.9646 73.9677 59.4552C75.3747 52.9458 81.8133 48.7582 88.5069 50.1264C90.8949 50.624 92.9841 51.7434 94.7319 53.3604C97.6311 56.2627 98.8677 60.3673 98.0577 64.3061Z"
        fill="#DC3636"
      />
      <path
        d="M84.206 55.9539L84.2066 55.9587L84.6938 62.0048C84.7352 62.7246 85.2902 63.3673 86.0012 63.3673C86.7122 63.3673 87.2672 62.7246 87.3086 62.0048L87.7958 55.9587L87.7964 55.9532C87.8696 54.7791 87.0932 53.7673 86.0012 53.7673C84.9056 53.7673 84.1328 54.8204 84.206 55.9539Z"
        fill="white"
        stroke="white"
      />
      <path
        d="M86.0012 65.7673C85.0022 65.7673 84.2012 66.5683 84.2012 67.5673C84.2012 68.5663 85.0022 69.3673 86.0012 69.3673C87.0002 69.3673 87.8012 68.5663 87.8012 67.5673C87.8012 66.5683 87.0002 65.7673 86.0012 65.7673Z"
        fill="white"
        stroke="white"
      />
      <path
        d="M157.824 94.3287V96.4774C157.824 98.8947 155.676 101.043 153.259 101.043H18.7422C16.3257 101.043 14.1777 98.8947 14.1777 96.4774V94.3287H157.824Z"
        fill="#D7DAEB"
      />
      <path
        d="M98.6196 94.3287V95.1345C98.6196 96.4774 97.5456 97.8203 95.9346 97.8203H76.0659C74.7234 97.8203 73.3809 96.746 73.3809 95.1345V94.3287H98.6196Z"
        fill="#F3F4F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.1196 31.1305C82.5096 31.521 82.5096 32.1542 82.1196 32.5447L79.7466 34.9177C79.3556 35.3083 78.7226 35.3083 78.3316 34.9177C77.9416 34.5272 77.9416 33.8941 78.3316 33.5035L80.7056 31.1305C81.0956 30.74 81.7286 30.74 82.1196 31.1305Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_10664_8817">
        <rect
          width={172}
          height={102}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAppointment1;
